/**
 * ResourceManagementPage - Resource management
 *
 * Surfaces the ResourceManager from @ferp/workflow-forms for admin/architect users.
 * Provides full CRUD management of compute, license, and expert pool resources.
 *
 * Route: /admin/resource-management
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconServer } from '@tabler/icons-react';

import { ResourceManager } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function ResourceManagementPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="orange">
            <IconServer size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Resource Management</Title>
            <Text size="sm" c="dimmed">
              Manage compute resources, licenses, and expert pool allocations
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ResourceManager tenant={tenant?.id ?? ''} />
    </Container>
  );
}

export default ResourceManagementPage;
